import classNames from 'classnames';
import { useCallback, forwardRef } from 'react';
const RETURN_KEY_CODE = 13;
const disabledContainerCss = "d17q9g2u";
const DisabledContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const tabIndex = -1;
  const inert = 'true';
  return <Component ref={ref} {...restProps} tabIndex={tabIndex} inert={inert} aria-hidden data-testid="disable-interaction" className={classNames(disabledContainerCss, props.className)} />;
});
export const DisableInteraction = ({
  children
}) => {
  const disableClickEvent = useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
  }, []);
  const disableKeyDownEvent = useCallback(e => {
    if (e.keyCode === RETURN_KEY_CODE) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, []);
  return <DisabledContainer onClickCapture={disableClickEvent} onKeyDown={disableKeyDownEvent}>
      {children}
    </DisabledContainer>;
};

require("./disable_interaction.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./disable_interaction.js");